import { createFileRoute } from "@tanstack/react-router";
import ListingChoice from "@/pages/ListingChoice";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/listeaza/")({
  head: () => routeHead("/listeaza/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ListingChoice />
  );
}
